module.exports = __webpack_public_path__ + "img/error-dark.d71b0cf8.svg";